"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackerDataType = void 0;
/**
 * What kind of data the tracker supports.The received data gets computed into a Quaternion rotation in any case.
 */
var TrackerDataType;
(function (TrackerDataType) {
    /**
     * Rotation (e.g: IMUs or computed rotations in firmware)
     */
    TrackerDataType[TrackerDataType["ROTATION"] = 0] = "ROTATION";
    /**
     * Flex resistance (e.g: raw data from flex sensors or unscaled angle on a single axis)
     */
    TrackerDataType[TrackerDataType["FLEX_RESISTANCE"] = 1] = "FLEX_RESISTANCE";
    /**
     * Flex angle (e.g: computed angle from flex sensors or angle on a single axis)
     */
    TrackerDataType[TrackerDataType["FLEX_ANGLE"] = 2] = "FLEX_ANGLE";
})(TrackerDataType = exports.TrackerDataType || (exports.TrackerDataType = {}));
